module.exports = __webpack_public_path__ + "static/media/39-1.e43b8bbb.png";